module.exports = __webpack_public_path__ + "img/bg_content_header_04.21876a1.png";